import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  @Input() title!: string;
  @Input() subtitle?: string;
  @Input() message?: string;
  @Input() caption?: string;
  @Input() closeButton?: string;
  @Input() confirmButton?: string;

  @Output() confirmed = new EventEmitter<void>()

  confirm() {
    this.confirmed.emit();
  }
}
